// ... existing code ...
import { defineStore } from 'pinia'
import pinia from '@/stores'
import { ref } from 'vue'
import { STORAGE_TOKEN_KEY, STORAGE_USER_INFO_KEY, STORAGE_LANG_KEY } from '@/stores/mutation-type'
import { loginApi, registerApi, logout } from '@/api/login' // , userInfoApi
import { maskString } from '@/utils/maskString'
import { initWebSocket, closeWebSocket } from '@/utils/websocketService'
import { useWebSocketStore } from '@/stores/websocketStore'
import { useEventBus } from '@vueuse/core'
import router from '@/router'

// const websocketUrl = 'ws://47.83.14.127:8282' // 替换为实际的 WebSocket URL
const imageModules = import.meta.glob('@/assets/theme/avatar/*.png', { eager: true })
export const useUserStore = defineStore('user', () => {
  const accoutToken = ref(localStorage.getItem(STORAGE_TOKEN_KEY) || '')
  const userInfo = ref(JSON.parse(localStorage.getItem(STORAGE_USER_INFO_KEY)) || {})
  const messageUnread = ref(0)

  // 注册
  async function register(data) {
    const res = await registerApi(data)
    setUserInfoFn(res)
    return res
  }

  // 登录
  async function handleLogin(data) {
    const res = await loginApi(data)
    setUserInfoFn(res)
    return res
  }

  // 设置用户信息
  async function setUserInfoFn(res) {
    if (res.code == 1 && res.data.token) {
      const { token, nickname } = res.data
      accoutToken.value = token
      userInfo.value = { ...res.data, maskNickname: maskString(nickname) }
      localStorage.setItem(STORAGE_TOKEN_KEY, token)
      localStorage.setItem(STORAGE_USER_INFO_KEY, JSON.stringify(userInfo.value))
    }
  }

  // 登出时需保留的应用基础配置（其余 localStorage   全部清除）
  const LOGOUT_LOCAL_STORAGE_KEEP_KEYS = [
    STORAGE_LANG_KEY,
    'theme',
    'localConfig',
    'initConfig',
    'deviceId',
    'id',
    'channel_id',
    'business_id',
  ]

  function clearLogoutCache() {
    const preserved = {}

    LOGOUT_LOCAL_STORAGE_KEEP_KEYS.forEach((key) => {
      const value = localStorage.getItem(key)
      if (value !== null) preserved[key] = value
    })

    localStorage.clear()
    Object.entries(preserved).forEach(([key, value]) => {
      localStorage.setItem(key, value)
    })
    localStorage.setItem('active', '0')
  }

  // 登出
  async function handleLogout() {
    const hadToken = !!accoutToken.value

    if (hadToken) {
      await logout()
    }

    accoutToken.value = ''
    userInfo.value = {}
    messageUnread.value = 0
    clearLogoutCache()
    closeWebSocket()

    if (hadToken) {
      const openLoginBus = useEventBus('open-login-popup')
      openLoginBus.emit()
    }

    router.push({ name: 'Home', query: { refresh: Date.now().toString() } })
  }

  /**
   * 昵称模块
   */
  // 更新昵称的方法
  function updateNickname(nickname) {
    userInfo.value.nickname = nickname
    userInfo.value.maskNickname = maskString(nickname)
    localStorage.setItem(STORAGE_USER_INFO_KEY, JSON.stringify(userInfo.value))
  }
  /**
   * 头像模块
   */
  function getAvatarImage(idx) {
    const imagePath = `/src/assets/theme/avatar/avatar${idx}.png`
    return imageModules[imagePath]?.default
  }

  /**
   * 获取本地所有头像并按性别分割
   */
  function getLocalAllAvatar() {
    const maleAvatars = [] // 男头：avatar0 - avatar23
    const femaleAvatars = [] // 女头：avatar24 - avatar47

    Object.keys(imageModules).forEach((key) => {
      const module = imageModules[key]
      // 提取头像编号
      const num = parseInt(key.split('/').pop().split('avatar').pop().split('.')[0])

      const avatarObj = {
        id: module?.default,
        url: module?.default,
        index: num,
        gender: num < 24 ? 'male' : 'female',
      }

      // 根据编号分割到不同数组
      if (num < 24) {
        maleAvatars.push(avatarObj)
      } else {
        femaleAvatars.push(avatarObj)
      }
    })
    // 对男头数组和女头数组分别按照 index 进行升序排序
    maleAvatars.sort((a, b) => a.index - b.index)
    femaleAvatars.sort((a, b) => a.index - b.index)
    return {
      male: maleAvatars, // 男头数组
      female: femaleAvatars, // 女头数组
      all: [...maleAvatars, ...femaleAvatars], // 所有头像（保持兼容性）
    }
  }

  /**
   * 获取男性头像列表 (avatar0 - avatar23)
   */
  function getMaleAvatars() {
    const avatars = getLocalAllAvatar()
    return avatars.male
  }

  /**
   * 获取女性头像列表 (avatar24 - avatar47)
   */
  function getFemaleAvatars() {
    const avatars = getLocalAllAvatar()
    return avatars.female
  }

  /**
   * 根据性别获取头像列表
   * @param {string} gender - 'male' 或 'female'
   */
  function getAvatarsByGender(gender) {
    const avatars = getLocalAllAvatar()
    return gender === 'male' ? avatars.male : avatars.female
  }

  // 获取用户头像的方法
  // function getUserAvatar() {
  //   return localStorage.getItem(STORAGE_USER_INFO_KEY)?.avatar || 0
  // }

  // 更新用户头像的方法
  function updateUserAvatar(avatarUrl) {
    userInfo.value.avatar = avatarUrl
    localStorage.setItem(STORAGE_USER_INFO_KEY, JSON.stringify(userInfo.value))
  }

  // 更新未读消息数量
  async function updateMessageUnread(data) {
    messageUnread.value = data
  }

  // 获取用户信息 idModal = { id ： xxx}
  // async function fetchUserInfo(idModal) {
  //   const res = await userInfoApi(idModal)
  //   if (res) {
  //     const { data } = res
  //     userInfo.value = data
  //     localStorage.setItem(STORAGE_USER_INFO_KEY, JSON.stringify({ ...data }))
  //     return true
  //   }
  // }

  return {
    token: accoutToken,
    userInfo,
    messageUnread,
    handleLogin,
    handleLogout,
    // fetchUserInfo,
    register,
    updateUserAvatar,
    getAvatarImage,
    getLocalAllAvatar,
    getMaleAvatars, // 新增：只获取男头
    getFemaleAvatars, // 新增：只获取女头
    getAvatarsByGender, // 新增：根据性别获取
    updateNickname,
    updateMessageUnread,
  }
})
// ... existing code ...
